import { createAttensiFetchError } from '@attensi/v3-client-wip'

const IS_DEV = process.env.NODE_ENV === 'development'

type ApiServiceResult = {
  error: boolean
  status: number
  statusText: string
  data: any
  url: string
  method: string
}

type Fetcher = () => Promise<ApiServiceResult>

export const wrapV1ApiService = async <T>(fetcher: Fetcher): Promise<T> => {
  try {
    return await runFetcher(fetcher)
  } catch (error: any) {
    const { showErrorPopup } = await import('@attensi/error-popup')
    showErrorPopup({ error, skipLandingPage: IS_DEV })
    throw error
  }
}

const runFetcher = async (fetcher: Fetcher) => {
  const res = await fetcher()

  if (res.error) {
    throw createAttensiFetchError({
      message: 'HTTP Status ' + res.status,
      url: res.url,
      method: res.method,
      status: res.status,
    })
  }

  return res.data
}
